import Menu from './Menu';
import Sns from './Sns';
import Name from './Name';

export default {
  Menu,
  Sns,
  Name,
};
